import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCardLayoutLarge24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCardLayoutLarge24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.75 5.5H5A1.5 1.5 0 0 0 3.5 7v5.5h5.25zm1.5 4.25v2.75h4.25V9.75zm0-1.5h4.25V5.5h-4.25zM16 9.75v2.75h4.5V9.75zm4.5-1.5H16V5.5h3A1.5 1.5 0 0 1 20.5 7zM3.5 17v-3h17v3a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 17M22 17V7a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCardLayoutLarge24);
